var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64645 17.7264L4.5 17.8729V18.08V19V19.5H5H5.92H6.12711L6.27355 19.3536L15.3336 10.2936L15.6871 9.94L15.3336 9.58645L14.4136 8.66645L14.06 8.3129L13.7064 8.66645L4.64645 17.7264ZM18.0161 3.64319L18.0164 3.64356L20.3564 5.98356L20.3568 5.98392C20.403 6.02999 20.4396 6.08471 20.4646 6.14496C20.4896 6.2052 20.5024 6.26978 20.5024 6.335C20.5024 6.40023 20.4896 6.46481 20.4646 6.52505C20.4396 6.58529 20.403 6.64002 20.3568 6.68609L20.3564 6.68645L18.88 8.1629L15.8371 5.12L17.3136 3.64356L17.3139 3.64319C17.36 3.59703 17.4147 3.5604 17.475 3.53541C17.5352 3.51042 17.5998 3.49756 17.665 3.49756C17.7302 3.49756 17.7948 3.51042 17.855 3.53541C17.9153 3.5604 17.97 3.59703 18.0161 3.64319ZM17.1029 9.94L6.54289 20.5H3.5V17.4571L14.06 6.89711L17.1029 9.94Z",
    fill: "#ACACAC",
    stroke: "#ACACAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2ae5346648fc7b3c618782e711dd5a94.svg";
export { ForwardRef as ReactComponent };